import { render, staticRenderFns } from "./CamaraHistoricoPantalla.vue?vue&type=template&id=5daf094e&scoped=true&"
import script from "./CamaraHistoricoPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraHistoricoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf094e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5daf094e', component.options)
    } else {
      api.reload('5daf094e', component.options)
    }
    module.hot.accept("./CamaraHistoricoPantalla.vue?vue&type=template&id=5daf094e&scoped=true&", function () {
      api.rerender('5daf094e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Historico/CamaraHistoricoPantalla.vue"
export default component.exports